import { BehaviorSubject } from 'rxjs';
import { Ring } from './chain.class';
import { AbstractTable } from './context/abstract/table.class';

export class Rows<D extends object> implements Ring<D[]>  {
   public input: BehaviorSubject<D[]>;
   public output = new BehaviorSubject<D[]>([]);
   public height: number;

   constructor(
      private ctx: AbstractTable<D>,
      readonly maxVisibleCount: number,
   ) {
      this.maxVisibleCount = maxVisibleCount || Infinity;
   }


   public subscribe() {
      return this.input.subscribe(rows => {
         const visible = this.ctx.viewport.build(rows);

         this.output.next(visible);
         this.ctx.dom.calibrateSizes();
      });
   }
}


